import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { SearchState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<SearchState, RootState> = {
//   addresslist: (state: SearchState) => state.cardnumber,
// };

/**
 * mutations
 */
export const mutations: MutationTree<SearchState> = {
  // 搜索关键字变化
  KEYWIRDSCHANGE(state: SearchState, payload: any) {
    state.kewords = payload;
  }
};

/**
 * state
 */
export const state: SearchState = {
  kewords: ''
};
const namespaced: boolean = true;

export const search: Module<SearchState, RootState> = {
  namespaced,
  state,
  // getters,
  mutations
};
